var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounTravelItinerary4236219(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,119)",
    d: "m0 0h477l3 2-1 238h599v-238l2-2h477l3 2v1926l-1 1h-1560l-1-6v-1921zm1095 444-159 159-2 1-334 1-1 11v108l5 1h210l-179 179-155 1-1 11v108l6 1 199-1 3-2v-2h2v-2h2v-2h2l7-8 167-167 6-5 6-7 2-1v-2h2v-2h2l7-8 7-6v214l117 1 2-1 1-336h2v-2h2v-2l4-2v-2l4-2v-2h2l7-8 135-135 5-4-1-4-81-81zm-855 701-1 11v108l117 1 2-1v-119zm240 0-1 20v99l5 1h833l1-1v-119zm-240 240-1 19v100l117 1 2-1v-119zm240 0-1 23v96l5 1h833l1-1v-119zm-240 240-1 19v100l117 1 2-1v-119zm240 0-1 23v96l5 1h832l2-1v-119z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844)",
    d: "m0 0h360l1 7v231l-1 2h-360l-1-1v-238z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounTravelItinerary4236219);
export default __webpack_public_path__ + "static/media/noun-travel-itinerary-4236219.6cc78dae80a0223482802f2bf299a024.svg";
export { ForwardRef as ReactComponent };